import authService from './authService';

let BASE_URL = process.env.REACT_APP_API_URL

async function loadConfig() {
    try {
        const response = await fetch("/config.json");
        const config = await response.json();
        BASE_URL = config.API_URL || BASE_URL; 
        //console.log("API URL Loaded:", BASE_URL);
    } catch (error) {
        console.error("Failed to load config.json. Using default .env API URL", error);
    }
}

loadConfig().then(() => {
    //console.log("Config initialized");
});

export async function getAssessmentControlInfo(complianceId:any,domainId:any,controlId:any) {
    try {
      const response = await authService.apiCall(`${BASE_URL}/compliance-control-actions/compliance/${complianceId}/domain/${domainId}/control/${controlId}`, {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error('Failed to get controls');
      }

      const result = await response.json();
      return result;
    } catch (error:any) {
        throw new Error(error);
    }
};



export async function createTask(data:any) {
 
    try {
      const response =await authService.apiCall(`${BASE_URL}/compliance-control-actions`, {
        method: 'POST',
      
        body: JSON.stringify(data)
      });   
      if (!response.ok) {
        throw new Error('Failed to create task');
      }
      const result = await response.json();
      return result;
    } catch (error:any) {
        throw new Error(error);
    }
};




export async function editTask(id: any, data: any, justification?: any, affectedAreas?: any) {
 
    try {
      const body = JSON.stringify({
        ...data,
        ...(justification && { justification }),
        ...(affectedAreas && { affectedAreas })
      });

      const response = await authService.apiCall(`${BASE_URL}/compliance-control-actions/${id}`, {
        method: 'PUT',
      
        body: body
      });

      if (!response.ok) {
        throw new Error('Failed to edit task');
      }
      const result = await response.json();
      return result;
    } catch (error: any) {
        throw new Error(error);
    }
};


export async function addTaskComment(data:any) {
 
    try {
      const response = await authService.apiCall(`${BASE_URL}/compliance-control-actions-comments`, {
        method: 'POST',
      
        body: JSON.stringify(data)
      });   
      if (!response.ok) {
        throw new Error('Failed to add task');
      }
      const result = await response.json();
      return result;
    } catch (error:any) {
        throw new Error(error);
    }
};

export async function uploadFiles(formData: FormData) {
  try {
    const response = await authService.apiCall(`${BASE_URL}/upload/compliance-control-action-files`, {
      method: 'POST',
      body: formData
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Failed to upload files');
    }
    
    const result = await response.json();
    return result;
  } catch (error: any) {
    console.error('File upload error:', error);
    throw new Error(error.message || 'File upload failed');
  }
}

export async function deleteFile(fileId:any) {
 
    try {
      const response = await authService.apiCall(`${BASE_URL}/compliance-control-actions/file/${fileId}`, {
        method: 'DELETE',
      
      });
      if (!response.ok) {
        throw new Error('Failed to delete file');
      }
      const result = await response.json();
      return result;
    } catch (error:any) {
        throw new Error(error);
    }
};

export async function saveAssessmentMetrics(data: { metrics: { category: string; key: string; value: number }[] }) {
  try {
    const response = await authService.apiCall(`${BASE_URL}/compliance-control-actions-factors`, {
      method: 'POST',
      
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      throw new Error('Failed to save metrics');
    }
    const result = await response.json();
    return result;
  } catch (error: any) {
    throw new Error(error);
  }
}

